import React from "react";
import { BottomSheet } from "../bottomSheet/BottomSheet";
import "./AuthorizeNetBottomSheet.css";
import { AddCardForm } from "./AddCardForm";
import cross from "../../assets/back.png";
import { usePaymentStore } from "../../stores/StoreContext";

interface AuthorizeNetBottomSheetProps {
  isVisible: boolean;
  onClose: () => void;
}

export const AuthorizeNetBottomSheet: React.FC<
  AuthorizeNetBottomSheetProps
> = ({ isVisible, onClose }) => {
  const paymentStore = usePaymentStore();
  return (
    <BottomSheet isVisible={isVisible} onClose={onClose}>
      <div className="authorize-net-container">
        <img
          onClick={() => {
            paymentStore.setIsAddCardSheetVisible(false);
          }}
          src={cross}
          alt=""
          style={{ height: 20, width: 12 }}
        />
        <AddCardForm />
      </div>
    </BottomSheet>
  );
};
